export default {
  brandColor1: '#f1f1f1',
  complimentaryColor1: '#000',
  brandColor2: '#3d2874',
  complimentaryColor2: '#fff',
};
